export const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: 'Arial, sans-serif' },
  header: { backgroundColor: '#2c3e50', color: 'white', padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { margin: 0, fontSize: '24px' },
  headerButtons: { display: 'flex', gap: '10px' },
  navButton: { padding: '8px 16px', backgroundColor: '#34495e', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', transition: 'background-color 0.2s' },
  navButtonActive: { backgroundColor: '#3498db' },
  navButtonDisabled: { backgroundColor: '#95a5a6', cursor: 'not-allowed', opacity: 0.6 },
  logoutButton: { padding: '8px 16px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px' },
  content: { display: 'grid', gridTemplateColumns: '1.2fr 2fr', gap: '20px', padding: '20px', maxWidth: '1800px', margin: '0 auto' },
  formSection: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  tableSection: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
  sectionTitle: { marginTop: '20px', marginBottom: '15px', fontSize: '18px', fontWeight: 'bold', color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '8px' },
  searchContainer: { position: 'relative', marginBottom: '20px' },
  searchInput: { width: '100%', padding: '10px', fontSize: '14px', border: '2px solid #3498db', borderRadius: '4px', boxSizing: 'border-box' },
  searchResults: { position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ddd', borderRadius: '4px', maxHeight: '300px', overflowY: 'auto', zIndex: 1000, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
  searchResultItem: { padding: '12px', borderBottom: '1px solid #eee', cursor: 'pointer', transition: 'background-color 0.2s' },
  searchResultItemSelected: { backgroundColor: '#e3f2fd' },
  searchResultDetail: { fontSize: '12px', color: '#666', marginTop: '4px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column' },
  label: { marginBottom: '5px', fontSize: '14px', fontWeight: 'bold', color: '#34495e' },
  input: { padding: '8px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' },
  textarea: { padding: '8px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px', resize: 'vertical', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' },
  formatPreview: { fontSize: '12px', color: '#3498db', marginTop: '4px', fontWeight: 'bold' },
  templateListContainer: { display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px', marginBottom: '8px' },
  templateItem: { display: 'flex', alignItems: 'center', gap: '4px', padding: '6px 10px', backgroundColor: '#f8f9fa', border: '2px solid #dee2e6', borderRadius: '4px', cursor: 'pointer', userSelect: 'none', transition: 'all 0.2s' },
  templateItemSelected: { backgroundColor: '#e3f2fd', borderColor: '#3498db', fontWeight: 'bold' },
  templateCheckbox: { cursor: 'pointer', margin: 0, width: '14px', height: '14px' },
  templateText: { fontSize: '13px' },
  applyButton: { marginTop: '8px', padding: '8px 16px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  materialResults: { marginTop: '8px', border: '1px solid #ddd', borderRadius: '4px', maxHeight: '200px', overflowY: 'auto', backgroundColor: 'white' },
  materialResultItem: { padding: '10px', borderBottom: '1px solid #eee', cursor: 'pointer', transition: 'background-color 0.2s' },
  materialResultItemSelected: { backgroundColor: '#e3f2fd' },
  materialRegister: { display: 'flex', gap: '8px', alignItems: 'center' },
  materialAddButton: { padding: '8px 16px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', whiteSpace: 'nowrap' },
  saveButton: { padding: '12px 24px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', marginTop: '20px', transition: 'all 0.3s ease' },
  saveButtonActive: { backgroundColor: '#ecf0f1', color: '#27ae60', border: '2px solid #27ae60', transform: 'scale(0.98)' },
  templateFormVertical: { display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' },
  tableContainer: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
  th: { backgroundColor: '#34495e', color: 'white', padding: '12px', textAlign: 'left', fontWeight: 'bold', position: 'sticky', top: 0 },
  tr: { borderBottom: '1px solid #ddd' },
  td: { padding: '12px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  loginContainer: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', fontFamily: 'Arial, sans-serif' },
  loginCard: { width: '100%', maxWidth: '420px', backgroundColor: 'white', borderRadius: '0', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden' },
  loginHeader: { padding: '60px 40px 50px', textAlign: 'center', background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)', color: 'white' },
  loginTitle: { fontSize: '56px', fontWeight: 'bold', margin: '0 0 16px 0', color: 'white', letterSpacing: '2px' },
  loginSubtitle: { fontSize: '28px', margin: 0, opacity: 0.95, color: 'white', fontWeight: '500' },
  loginForm: { padding: '40px' },
  inputWrapper: { position: 'relative', marginBottom: '20px' },
  loginInput: { width: '100%', padding: '14px', fontSize: '15px', border: '2px solid #e0e0e0', borderRadius: '0', boxSizing: 'border-box', transition: 'border-color 0.3s ease', outline: 'none' },
  loginButton: { width: '100%', padding: '14px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '0', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold', marginTop: '10px', transition: 'all 0.3s ease', boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)' },
  loginError: { color: '#e74c3c', backgroundColor: '#fadbd8', padding: '12px', borderRadius: '8px', marginBottom: '15px', fontSize: '14px', textAlign: 'center', border: '1px solid #f5c6cb' },
  tabs: { display: 'flex', gap: '10px', marginBottom: '20px', marginTop: '20px', borderBottom: '2px solid #ddd' },
  tab: { padding: '10px 20px', backgroundColor: 'transparent', border: 'none', borderBottom: '2px solid transparent', cursor: 'pointer', fontSize: '14px', color: '#666' },
  tabActive: { padding: '10px 20px', backgroundColor: 'transparent', border: 'none', borderBottom: '2px solid #3498db', cursor: 'pointer', fontSize: '14px', color: '#3498db', fontWeight: 'bold' },
  templateList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  templateListItem: { padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  templateContent: { fontSize: '12px', color: '#666', marginTop: '5px' },
  templateActions: { display: 'flex', gap: '10px' },
  editButton: { padding: '6px 12px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  deleteButton: { padding: '6px 12px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  materialList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  materialListItem: { padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  dbPageContainer: { display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px', maxWidth: '1800px', margin: '0 auto' },
  dbFilterSection: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flex: '0 0 auto' },
  dbTableSection: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', flex: '1 1 auto', minHeight: '600px' },
  filterGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '15px', marginTop: '15px' },
  resetButton: { padding: '8px 16px', backgroundColor: '#95a5a6', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', width: '100%' },
  resultCount: { padding: '8px 16px', backgroundColor: '#e8f4f8', borderRadius: '4px', fontSize: '14px', color: '#2c3e50', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  deleteButtonSmall: { padding: '4px 8px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  modal: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modalContent: { backgroundColor: 'white', borderRadius: '8px', width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' },
  modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', borderBottom: '1px solid #ddd' },
  modalCloseButton: { padding: '8px 16px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' },
  modalSaveButton: { padding: '8px 20px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold', transition: 'background-color 0.3s ease' },
  subTitle: { marginTop: '25px', marginBottom: '15px', fontSize: '16px', fontWeight: 'bold', color: '#2c3e50', paddingBottom: '8px', borderBottom: '2px solid #3498db' },
  paymentSummary: { backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '20px' },
  summaryItem: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: '15px' },
  addButton: { padding: '10px 20px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold', marginBottom: '20px' },
  paymentList: { display: 'flex', flexDirection: 'column', gap: '10px' },
  paymentItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' },
  historyList: { display: 'flex', flexDirection: 'column', gap: '15px' },
  historyItem: { padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #dee2e6' },
  historyTime: { fontSize: '12px', color: '#666', marginBottom: '5px' },
  historyField: { fontSize: '14px', marginBottom: '8px' },
  historyChange: { fontSize: '14px', display: 'flex', alignItems: 'center' },
  oldValue: { padding: '4px 8px', backgroundColor: '#ffebee', borderRadius: '4px', color: '#c62828' },
  newValue: { padding: '4px 8px', backgroundColor: '#e8f5e9', borderRadius: '4px', color: '#2e7d32' },
  recordFilterBar: { display: 'flex', gap: '10px', marginBottom: '15px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', alignItems: 'center', flexWrap: 'wrap' },
  recordFilterInput: { flex: '2', minWidth: '200px', padding: '8px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px' },
  recordFilterDate: { flex: '1', minWidth: '140px', padding: '8px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px' },
  recordFilterSelect: { flex: '1', minWidth: '120px', padding: '8px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '4px' },
  recordFilterReset: { padding: '8px 16px', backgroundColor: '#95a5a6', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', whiteSpace: 'nowrap' },
  recordFilterCount: { padding: '8px 16px', backgroundColor: '#e3f2fd', borderRadius: '4px', fontSize: '14px', color: '#2c3e50', fontWeight: 'bold', whiteSpace: 'nowrap' },
  userActions: { display: 'flex', gap: '8px', justifyContent: 'center' },
  roleButton: { padding: '6px 12px', backgroundColor: '#f39c12', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' },
  adminBadge: { padding: '4px 12px', backgroundColor: '#e74c3c', color: 'white', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', display: 'inline-block' },
  userBadge: { padding: '4px 12px', backgroundColor: '#95a5a6', color: 'white', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold', display: 'inline-block' },
  exportButton: { padding: '8px 16px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  backupButton: { padding: '8px 16px', backgroundColor: '#2980b9', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  downloadButton: { padding: '4px 8px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px' },
  readOnlyText: { padding: '12px', backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '14px', color: '#495057', minHeight: '40px' },
/* 여기서부터 아래 내용을 복사해서 추가하세요 */
  dashboardContainer: {
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    margin: '0 auto',
    maxWidth: '1600px'
  },
  tableHeader: {
    backgroundColor: '#f8f9fa',
    color: '#34495e',
    padding: '15px',
    textAlign: 'left',
    fontSize: '15px',
    fontWeight: 'bold',
    borderBottom: '2px solid #edf2f7',
    letterSpacing: '0.5px'
  },
  tableRow: {
    borderBottom: '1px solid #edf2f7',
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  },
  statusBadge: (status) => {
    const base = {
      padding: '5px 12px',
      borderRadius: '15px',
      fontSize: '12px',
      fontWeight: 'bold',
      display: 'inline-block',
      textAlign: 'center',
      minWidth: '60px'
    };
    switch(status) {
      case '완결': return { ...base, backgroundColor: '#e1f7e3', color: '#27ae60' };
      case '진행': return { ...base, backgroundColor: '#fff4e5', color: '#f39c12' };
      default: return { ...base, backgroundColor: '#f0f2f5', color: '#7f8c8d' };
    }
  },
  textEllipsis: {
    maxWidth: '350px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  responsiveTable: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed', // 너비 고정을 위해 필수
  },
  // 컬럼별 고정 폭 정의
  colDate: { width: '100px' },
  colName: { width: '120px' },
  colManager: { width: '100px' },
  colPhone: { width: '130px' },
  colMobile: { width: '130px' },
  colCost: { width: '110px' },
  colStatus: { width: '90px', textAlign: 'right' }, // 상태는 우측 끝
  // 가변 폭 (내역들)
  colFlexible: { width: 'auto' }, 
  
  // 텍스트 생략 공통 스타일
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  // src/styles/styles.js

// ... 기존 스타일 유지 ...
  dashboardWrapper: {
    display: 'flex',
    gap: '25px',
    padding: '20px',
    maxWidth: '1800px',
    margin: '0 auto',
    alignItems: 'flex-start'
  },
  // 좌측 입력 폼 (고정 폭 1의 비중)
  formContainer: {
    flex: '0 0 450px',
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    position: 'sticky', // 스크롤 시 폼 고정
    top: '20px'
  },
  // 우측 리스트 (가변 폭 2의 비중)
  listContainer: {
    flex: '1',
    backgroundColor: 'white',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    minWidth: '0' // flex 아이템 내부 테이블 가변폭 보장
  },
  formTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #f0f2f5',
    color: '#2c3e50'
  },
  inputGroup: {
    marginBottom: '15px'
  },
  label: {
    display: 'block',
    marginBottom: '5px',
    fontSize: '14px',
    color: '#636e72',
    fontWeight: '600'
  },
  // 🆕 추가된 스타일
  formSectionTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '15px',
    paddingBottom: '8px',
    borderBottom: '2px solid #3498db',
    color: '#2c3e50',
    marginTop: '20px'
  },
  filterBar: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    marginBottom: '15px',
    flexWrap: 'wrap'
  },
  dateInput: {
    padding: '8px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white'
  },
  selectInput: {
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white',
    cursor: 'pointer'
  },
  resetButton: {
    padding: '8px 16px',
    backgroundColor: '#95a5a6',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  statsBar: {
    padding: '10px 15px',
    backgroundColor: '#ecf0f1',
    borderRadius: '6px',
    marginBottom: '15px',
    fontSize: '14px',
    color: '#2c3e50'
  },
  checkboxLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    fontSize: '14px',
    marginRight: '10px',
    cursor: 'pointer'
  },
  searchResultsDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    border: '2px solid #3498db',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    maxHeight: '300px',
    overflowY: 'auto',
    zIndex: 1000,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  },
  searchResultItem: {
    padding: '12px 15px',
    borderBottom: '1px solid #ecf0f1',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  }
};
